import { computed, ref } from 'vue'
import { avg, toSignificantDigits } from './fns'
import { finishedStepCount, totalWorkDuration } from '../app/execute/execute-state'

export const prevStats = ref()

export const defaultStepDurationMs = 10_000

const stats = computed(() => {
  const stepDuration = finishedStepCount.value > 0
    ? toSignificantDigits(5, totalWorkDuration.value / finishedStepCount.value)
    : defaultStepDurationMs
  return {
    prev: prevStats.value,
    current: {
      times: { stepDuration },
    },
  }
})

export const mergeStats = () => {
  if (!prevStats.value) {
    prevStats.value = {
      times: {
        stepDuration: stats.value.current.times.stepDuration,
      },
    }
  } else {
    prevStats.value = {
      times: {
        stepDuration: avg(stats.value.current.times.stepDuration, prevStats.value.times.stepDuration),
      },
    }
  }
}
